<div class="responsive-contr">
  <div class="container body">
    <div class="download">
      <div class="row">
        <div class="col-2">
          <div
            class="app-logo"
            style="
              background-image: url(../../../../assets/images/nadel-icon.webp);
            "></div>
        </div>
        <div class="col-10">
          <div class="app-header has-logo pt-2">
            <h1>Nadel Sales Mobile App</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="app-versions col">
          <div class="row">
            <div class="col-12 px-3">
              <p class="instructions">
                Please select a version below to get started:
              </p>
            </div>
            <div class="col-12">
              <div class="svg-icon" (click)="downloadAndNavigate(false)">
                <!-- Android SVG icon -->
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="android"
                  role="img"
                  viewBox="0 0 576 512"
                  class="platform-icon svg-inline--fa fa-android fa-w-18">
                  <path
                    fill="currentColor"
                    d="M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                    class=""></path>
                </svg>
                <span class="text"
                  >Android <span class="version">1.5.0</span></span
                >
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="svg-icon" (click)="downloadAndNavigate(true)">
                <!-- iOS SVG icon -->
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="apple"
                  role="img"
                  viewBox="0 0 384 512"
                  class="platform-icon svg-inline--fa fa-apple fa-w-18">
                  <path
                    fill="currentColor"
                    d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                    class=""></path>
                </svg>
                <span class="text">iOS <span class="version">1.5.0</span></span>
              </div>
            </div>
            <div class="col-12">
              <p class="instructions">
                Once your download starts, we'll show you how to get your app
                installed. Take a look, as it might not be what you're used to!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
